import { observable, action } from 'mobx'
import Service, { IData } from '@services/api/practicalTrain'

export interface IPracticeTrain {
  trainingName: string
}
class PracticeTrain implements IPracticeTrain {
  @observable public trainingName = '' // 培训项目名称
}
export default new PracticeTrain()
